import { formatAbsolutoConHora, formatRelativo, toDate } from "@/lib/format/fechas";
import { cn } from "@/lib/utils/cn";

interface FechaRelativaProps {
  fecha: Date | string;
  className?: string;
}

/**
 * Texto relativo "hace 3 días" con tooltip de la fecha absoluta.
 * Usa `<time>` para semántica correcta y accesibilidad.
 */
export function FechaRelativa({ fecha, className }: FechaRelativaProps) {
  const date = toDate(fecha);
  const relativo = formatRelativo(date);
  const absoluto = formatAbsolutoConHora(date);

  return (
    <time
      dateTime={date.toISOString()}
      title={absoluto}
      aria-label={absoluto}
      className={cn("text-sm text-muted-foreground", className)}
      data-testid="fecha-relativa"
    >
      {relativo}
    </time>
  );
}
